/**
 * Created by tofael on 11/22/17.
 */
const NODE_ENV = process.env.REACT_APP_NODE_ENV || 'development';

const development = {
  api_host: 'http://localhost:3000',
  api_url: 'http://localhost:3000/api/v1',
  doc_url: 'http://localhost:3000/docs/'
};

const staging = {
  api_host: 'https://api-staging.olwel.com',
  api_url: 'https://api-staging.olwel.com/api/v1',
  doc_url: 'https://api-staging.olwel.com/docs/'
};

const production = {
  api_host: 'https://api.olwel.com',
  api_url: 'https://api.olwel.com/api/v1',
  doc_url: 'https://api.olwel.com/docs/'
};

let apiConfig = {};

if (NODE_ENV === 'production') {
  apiConfig = production;
} else if (NODE_ENV === 'staging') {
  apiConfig = staging;
} else if (NODE_ENV === 'development') {
  apiConfig = development;
}

export default apiConfig;



// WEBPACK FOOTER //
// ./src/utility/api-config.js